import { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import { appservice } from "../services/app.service";
import { dashboardservice } from "../services/dashboard.service";
import AuthContext from "../store/auth-context";

import TextField from "@material-ui/core/TextField";
import { KeyboardDatePicker } from "@material-ui/pickers";
import MenuItem from "@material-ui/core/MenuItem";
import moment from "moment";

import { useTranslation } from "react-i18next";
import { Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";

import NumberFormat from "react-number-format";

const PersonalDetails = (props: any) => {
  const authCtx = useContext(AuthContext);
  const { t } = useTranslation();

  const [cList, setcList] = useState<any>([]);
  const [genderList, setGenderList] = useState<any>([]);
  const [docTypeList, setDocTypeList] = useState<any>([]);

  const [showModal, setShowModal] = useState<boolean>(false);
  const [modalText, setModalText] = useState<string>("");
  const [modalType, setModalType] = useState<string>("error");

  const [fName, setfName] = useState<string>("");

  const [fNameError, setFnameError] = useState<boolean>(false);

  const [lName, setlName] = useState<string>("");
  const [lNameError, setLnameError] = useState<boolean>(false);

  const [gender, setGender] = useState<string>("");
  const [genderError, setGenderError] = useState<boolean>(false);

  const [mobile, setMobile] = useState<string>("");
  const [mobileCode, setMobileCode] = useState<string>("");

  const [selectedDOB, setSelectedDOB] = useState<Date | null>(null);
  const [patientDOB, setPatientDOB] = useState<any>();
  const [selectedDOBError, setSelectedDOBError] = useState<boolean>(false);
  const [selectedDOBErrorText, setSelectedDOBErrorText] = useState<string>("");

  const [email, setEmail] = useState<string>("");
  const [emailError, setEmailError] = useState<boolean>(false);
  const [emailErrorText, setEmailErrorText] = useState<string>("");

  const [docId, setDocId] = useState<string>("");
  const [docIdError, setDocIdError] = useState<boolean>(false);
  const [docIdErrorText, setDocIdErrorText] = useState<string>("");

  const [docType, setDocType] = useState(0);
  const [docTypeError, setDocTypeError] = useState<boolean>(false);

  const [country, setCountry] = useState<string>("");
  const [countryError, setCountryError] = useState<boolean>(false);
  const [initials, setInitials] = useState<string>("");

  let userInfo = JSON.parse(localStorage.getItem("user") || "{}");
  let uaeUserInfo = JSON.parse(
    localStorage.getItem("uaeUser") || "0"
  ).toString();

  useEffect(() => {
    const getCountryCode = async () => {
      const listFromApi = await fetchCountryCode();
      setcList(listFromApi);
    };
    getCountryCode();
    setMobileData();

    const getDocumentTypeList = async () => {
      const listFromApi = await fetchDocTypeList();
      setDocTypeList(listFromApi);
    };
    getDocumentTypeList();

    const getGenderList = async () => {
      const listFromApi = await fetchGenderList();
      setGenderList(listFromApi);
      // setGender(listFromApi[0].id);
    };
    getGenderList();

    fetchUserProfile();

    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    getInitials();
  }, []);

  const setMobileData = () => {
    let userInfo = JSON.parse(localStorage.getItem("user") || "{}");
    setMobile(userInfo.mobile);
    setMobileCode(userInfo.callingCode);
  };

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  const fetchCountryCode = async () => {
    let res = await appservice.getCountryList();
    return res;
  };

  const fetchGenderList = async () => {
    let res = await appservice.getGender();
    return res;
  };
  const fetchDocTypeList = async () => {
    let res = await appservice.getDocumentType();
    return res;
  };

  const fetchUserProfile = async () => {
    let res = await dashboardservice.getProfile();
    if (
      res &&
      res.data &&
      res.message &&
      res.message.status &&
      res.message.status === "Success"
    ) {
      setfName(res.data.firstName);
      setlName(res.data.lastName);
      setGender(res.data.genderId);
      setSelectedDOB(res.data.dateOfBirth);
      setPatientDOB(res.data.dateOfBirth.slice(0, 10));
      setEmail(res.data.email);
      setDocId(res.data.documentId);
      setDocType(res.data.documentTypeId);
      setCountry(res.data.countryId);
    }
  };

  const getInitials = () => {
    let userData = JSON.parse(localStorage.getItem("user") || "{}");
    const fullName = userData.firstName + " " + userData.lastName;
    const names = fullName.split(" ");
    let initials = names[0].substring(0, 1).toUpperCase();
    if (names.length > 1) {
      initials += names[names.length - 1].substring(0, 1).toUpperCase();
    }
    setInitials(initials);
  };

  function validateForm() {
    let isValid: boolean = true;
    if (fName.trim() === "") {
      setFnameError(true);
      isValid = false;
    }
    if (lName.trim() === "") {
      setLnameError(true);
      isValid = false;
    }
    if (gender === null) {
      setGenderError(true);
      isValid = false;
    }
    if (selectedDOB === null || selectedDOBError) {
      setSelectedDOBError(true);
      isValid = false;
    }

    if (email.trim() === "" || emailError) {
      setEmailError(true);
      isValid = false;
    }
    if (docId.trim() === "" || docIdError) {
      setDocIdError(true);
      isValid = false;
    }
    if (country === null || countryError) {
      setCountryError(true);
      isValid = false;
    }
    if (docType === null || docType === 0 || docTypeError) {
      setDocTypeError(true);
      isValid = false;
    }

    return isValid;
  }

  function checkEmirateId() {
    let isValid: boolean = true;
    if (docType.toString() === "1") {
      const emirateId = docId;
      const dobYear = moment(selectedDOB, "YYYY-MM-DD").format("YYYY");
      const compereCodeWith =
        "784" + dobYear + emirateId.toString().slice(7, emirateId.length);
      if (emirateId !== compereCodeWith) {
        isValid = false;
      }
    }
    return isValid;
  }

  let handleSubmit = async () => {
    let data;
    if (validateForm()) {
      if (checkEmirateId()) {
        authCtx.toggleLoader(true);
        data = {
          firstName: fName.trim(),
          lastName: lName.trim(),
          email: email.trim(),
          dateOfBirth: patientDOB,
          genderId: gender,
          countryId: country,
          documentTypeId: docType,
          documentId: docId,
        };
        let res = await dashboardservice.saveProfile(data);
        if (res.message.status === "Success") {
          authCtx.toggleLoader(false);
          authCtx.setUserProfileDetails(res.data);
          let userInfo = JSON.parse(localStorage.getItem("user") || "{}");
          userInfo.firstName = res.data.firstName;
          userInfo.lastName = res.data.lastName;
          localStorage.setItem("user", JSON.stringify(userInfo));
          localStorage.removeItem("getPatientRecord");
          localStorage.setItem("isPatientRecordCall", "false");
          getInitials();
          props.reloadPage();
          setModalText(t("Profile updated successfully"));
          handleShow();
          setModalType("success");
          setTimeout(() => {
            setModalText("");
            handleClose();
            fetchUserProfile();
          }, 3000);
        } else {
          authCtx.toggleLoader(false);
          setModalText(t("Error"));
          handleShow();
          setModalType("error");
          setTimeout(() => {
            setModalText("");
            handleClose();
            fetchUserProfile();
          }, 3000);
        }
      } else {
        authCtx.toggleLoader(false);
        setShowModal(true);
        setModalType("error");
        setModalText(t("Invalid Emirates Id or date of birth"));
      }
    }
  };
  const handleDOBChange = (date: any | null) => {
    if (date !== null && date.toString() !== "Invalid Date") {
      const offset = date.getTimezoneOffset();
      date = new Date(date.getTime() - offset * 60 * 1000);
      setSelectedDOB(date);
      setPatientDOB(date.toISOString().slice(0, 10));
    }
    let isValid = moment(date, "DD/MM/YYYY", true).isValid();
    if (isValid) {
      let today = moment(new Date().getDate() + 1, "DD/MM/YYYY");
      let selectedDate = moment(date, "DD/MM/YYYY");
      if (moment(selectedDate).isAfter(today)) {
        setSelectedDOBError(true);
        setSelectedDOBErrorText(t("dobRangeError"));
      } else {
        setSelectedDOBError(false);
        setSelectedDOBErrorText("");
      }
    } else {
      setSelectedDOBError(true);
      setSelectedDOBErrorText(t("dobFormatError"));
    }
  };

  const handleInputChange = (
    e: any,
    setterName: any,
    errorSetterName?: any
  ) => {
    setterName(e.target.value);
    if (errorSetterName) {
      if (e.target.value === "" || e.target.value.trim() === "") {
        errorSetterName(true);
      } else {
        errorSetterName(false);
      }
    }
  };

  const handleDocIdChange = (e: any) => {
    let pattern = /^784[0-9]{12}$/;
    if (docType === 1) {
      let text = e.target.value;
      let emirateId = text.replace(/-/g, "").trim();
      setDocId(emirateId);
      if (pattern.test(emirateId)) {
        if (emirateId.length < 8) {
          setDocIdError(true);
          setDocIdErrorText(t("Please enter valid Emirates ID"));
        } else {
          setDocIdError(false);
          setDocIdErrorText("");
        }
      } else {
        setDocIdError(true);
        setDocIdErrorText(t("Please enter valid Emirates ID"));
      }
    } else {
      setDocId(e.target.value);
      if (e.target.value === "" || e.target.value.trim() === "") {
        setDocIdError(true);
        setDocIdErrorText("");
      } else if (e.target.value.length < 6) {
        setDocIdError(true);
        setDocIdErrorText(t("Please enter correct Document ID"));
      } else {
        setDocIdError(false);
        setDocIdErrorText("");
      }
    }
  };

  const handleEmailChange = (e: any) => {
    setEmail(e.target.value);
    if (e.target.value === "" || e.target.value.trim() === "") {
      setEmailError(true);
      setEmailErrorText("");
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(e.target.value)
    ) {
      setEmailError(true);
      setEmailErrorText(t("lease enter valid Email ID"));
    } else {
      setEmailError(false);
      setEmailErrorText("");
    }
  };

  return (
    <>
      <div className="d-block d-sm-flex align-items-center my-4">
        <div className="flex-shrink-0">
          <div className="initials d-flex align-items-center justify-content-center text-primary rounded-circle light-bg">
            <h1>{initials}</h1>
          </div>
        </div>
      </div>
      <div className="row g-sm-3">
        <div className="col-sm">
          <div className="form-floating mb-3">
            <TextField
              required
              id="fName"
              label={t("First Name*")}
              className="w-100  "
              variant="outlined"
              size="small"
              disabled={uaeUserInfo === "1" ? true : false}
              error={fNameError}
              value={fName}
              onChange={(e: any) => {
                handleInputChange(e, setfName, setFnameError);
              }}
            />
          </div>
        </div>
        <div className="col-sm">
          <div className="form-floating mb-3">
            <TextField
              required
              id="lName"
              label={t("Last Name*")}
              className="w-100  "
              variant="outlined"
              size="small"
              disabled={uaeUserInfo === "1" ? true : false}
              error={lNameError}
              value={lName}
              onChange={(e: any) => {
                handleInputChange(e, setlName, setLnameError);
              }}
            />
          </div>
        </div>
      </div>
      <div className="mb-3">
        <div className="input-group">
          <TextField
            required
            id="mobile"
            label={t("Mobile No.*")}
            disabled
            className="w-100 avoid-clicks"
            variant="outlined"
            size="small"
            type="tel"
            inputProps={{ maxLength: 10 }}
            value={"+" + mobileCode + " " + mobile}
          />
        </div>
      </div>
      <div className="row g-sm-3">
        <div className="col-sm">
          <div className="form-floating mb-3">
            <TextField
              required
              id="email"
              label={t("Email ID*")}
              className="w-100  "
              variant="outlined"
              size="small"
              disabled={uaeUserInfo === "1" ? true : false}
              error={emailError}
              helperText={emailErrorText}
              value={email}
              onChange={(e: any) => {
                handleEmailChange(e);
              }}
            />
          </div>
        </div>
        <div className="col-sm">
          <div className="form-floating mb-3">
            <KeyboardDatePicker
              required
              autoOk={true}
              disableFuture
              size="small"
              variant="inline"
              inputVariant="outlined"
              format="dd/MM/yyyy"
              margin="dense"
              id="dob"
              views={["year", "month", "date"]}
              label={t("DOB*")}
              error={selectedDOBError}
              helperText={selectedDOBErrorText}
              value={selectedDOB}
              onChange={handleDOBChange}
              KeyboardButtonProps={{
                "aria-label": "change date",
              }}
              className="m-0  w-100"
            />
          </div>
        </div>
      </div>
      <div className="row g-sm-3">
        <div className="col-sm">
          <div className="form-floating mb-3">
            <TextField
              required
              select
              id="gender"
              label={t("Gender*")}
              className="w-100  "
              variant="outlined"
              size="small"
              disabled={uaeUserInfo === "1" ? true : false}
              error={genderError}
              value={gender}
              onChange={(e: any) => {
                setGender(e.target.value);
                setGenderError(false);
              }}
            >
              {genderList &&
                genderList.map((item: any) => (
                  <MenuItem value={item.id} key={item.id}>
                    {item.text}
                  </MenuItem>
                ))}
            </TextField>
          </div>
        </div>
        <div className="col-sm">
          <div className="form-floating mb-3">
            <TextField
              required
              select
              id="country"
              label={t("Nationality")}
              className="w-100  "
              variant="outlined"
              size="small"
              disabled={uaeUserInfo === "1" ? true : false}
              error={countryError}
              value={country}
              onChange={(e: any) => {
                setCountry(e.target.value);
                setCountryError(false);
              }}
            >
              {cList &&
                cList.map((country: any) => (
                  <MenuItem value={country.id} key={country.id}>
                    {country.text}
                  </MenuItem>
                ))}
            </TextField>
          </div>
        </div>
      </div>
      <div className="row g-sm-3">
        <div className="col-sm">
          <div className="form-floating mb-3">
            <TextField
              required
              select
              id="docType"
              label={t("Document Type*")}
              className="w-100  "
              variant="outlined"
              size="small"
              disabled
              error={docTypeError}
              value={docType === 0 ? "" : docType}
              onChange={(e: any) => {
                setDocType(e.target.value);
                setDocId("");
              }}
            >
              {docTypeList &&
                docTypeList.map((item: any) => (
                  <MenuItem value={item.id} key={item.id}>
                    {item.text}
                  </MenuItem>
                ))}
            </TextField>
          </div>
        </div>
        <div className="col-sm">
          <div className="form-floating mb-3">
            {docType === 1 ? (
              <NumberFormat
                required
                customInput={TextField}
                id="docId1"
                className="w-100"
                size="small"
                variant="outlined"
                format="###-####-#######-#"
                label={t("Document ID*")}
                disabled
                error={docIdError}
                helperText={docIdErrorText}
                value={docId}
                onChange={(e: any) => {
                  handleDocIdChange(e);
                }}
              />
            ) : (
              <TextField
                required
                id="docId"
                label={t("Document ID*")}
                className="w-100"
                variant="outlined"
                size="small"
                type="tel"
                inputProps={{ maxLength: 15 }}
                disabled
                error={docIdError}
                helperText={docIdErrorText}
                value={docId}
                onChange={(e: any) => {
                  handleDocIdChange(e);
                }}
              />
            )}
          </div>
        </div>
      </div>
      <div className="text-end">
        <button className="btn btn-primary" onClick={() => handleSubmit()}>
          {t("Save")}
        </button>
      </div>

      {modalType === "error" && (
        <Snackbar
          open={showModal}
          autoHideDuration={3000}
          onClose={handleClose}
        >
          <Alert onClose={handleClose} severity="error">
            {modalText}
          </Alert>
        </Snackbar>
      )}
      {modalType === "success" && (
        <Snackbar
          open={showModal}
          autoHideDuration={3000}
          onClose={handleClose}
        >
          <Alert onClose={handleClose} severity="success">
            {modalText}
          </Alert>
        </Snackbar>
      )}
    </>
  );
};

export default PersonalDetails;
